import React, { useState, useEffect, useRef, useCallback } from 'react';
import TreeList, {
  RemoteOperations, Column, Paging, Editing, Form, Texts, Popup as Popup2, Button, StateStoring
} from 'devextreme-react/tree-list';
import { Item, Label, Form as Form2, GroupItem, SimpleItem, ButtonItem, PatternRule } from 'devextreme-react/form';
import TenantService from "../../api/tenant.service";
import { Popup, Position } from 'devextreme-react/popup';
import SpacesService from '../../api/spaces.service';
import FloorplanPopup from '../components/floorplan'
import AssetsService from "../../api/assets.service";
import './spaces.css'
import Toast from 'components/Toast';
import DOMPurify from 'dompurify';
import Test from "../test"
import { useHistory } from "react-router";
import generatePDF, { Margin } from 'react-to-pdf';
import moment from 'moment-timezone';
import { LoadPanel as LoadingPanel } from 'devextreme-react/load-panel';
import { Tooltip } from 'devextreme-react';
import SlidingDrawer from 'components/sliding-drawer/SlidingDrawer';
// import SelectBox from 'devextreme-react/select-box';
// import TextBox from 'devextreme-react/text-box';
// import Validator, { RequiredRule } from 'devextreme-react/validator';
// import { ValidationGroup } from 'devextreme-react/validation-group';
import {
  Form as DxForm
} from 'devextreme-react/form';

export default function App() {
  const downloadTargetRef = useRef();
  const [popupVisible, setPopupVisible] = useState(false)
  const [spaceId, setSpaceId] = useState("")
  const [renderFloorplan, setRenderFloorplan] = useState(false)
  const [getAnchors, setGetAnchors] = useState(true)
  const [getGateways, setGetGateways] = useState(true)
  const [className, setClassName] = useState("")
  const [title, setTitle] = useState("")
  const [type, setType] = useState("")
  const [data, setData] = useState([])
  const [headData, setHeadData] = useState([])
  const [models, setModels] = useState([])
  const [types, setTypes] = useState([])
  const [toggleEditBool, setToggleEditBool] = useState(false)
  const [uploadPopupVisible, setUploadPopupVisible] = useState(false)
  const [uploadSpaceId, setUploadSpaceId] = useState("")
  const [zoneEditControl, setZoneEditControl] = useState(false);
  const [heightOfGrid, setHeightOfGrid] = useState('calc(100vh - 51px)');
  const [loading, setLoading] = useState(false);
  const [toastConfig, setToastConfig] = React.useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 5000,
  });
  const [editAllowed, setEditAllowed] = useState(false)
  const [loadingText, setLoadingText] = useState('Loading...');
  const [isOpen, setIsOpen] = useState(false);
  const [geoAllowed, setGeoAllowed] = useState(false);
  const [isOpenForm, setIsOpenForm] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [isNewRow, setIsNewRow] = useState(false);
  const formRef = useRef();
  const dxFormRef = useRef();
  const formFormRef = useRef();
  const dxFormFormRef = useRef();
  const validationGroupRef = useRef(null);
  const [formData, setFormData] = useState({
    id: null,
    name: '',
    model: { id: null },
    type: { id: null },
    headId: null,
  });
  const [formFormData, setFormFormData] = useState({
    id: null,
    name: '',
    model: { id: null },
    type: { id: null },
    headId: null,
  });
  const [prevData, setPrevData] = useState(null)
  const [prevFormData, setPrevFormData] = useState(null)

  const history = useHistory();
  useEffect(() => {
    if (history.location.state) {
      setToastConfig({
        isVisible: history.location.state.isVisible,
        type: history.location.state.type,
        message: history.location.state.message
      })
    }
  }, [history])

  const downloadReport = async () => {
    setLoading(true);
    await setHeightOfGrid('100%');
    await generatePDF(downloadTargetRef, {
      filename: `spaces-${moment().format('YYYY-MM-DD-HH-mm-ss')}.pdf`,
      page: { margin: Margin.LARGE }
    });
    await setHeightOfGrid('calc(100vh - 51px)');
    setLoading(false);
  }

  function checkRole() {
    let spaceConfig = false
    if (window.location.href.includes("config/space")) {
      spaceConfig = true
      setClassName("config-space-custom")
    } else {
    }
    var role = JSON.parse(localStorage.getItem("role"));
    let canEdit = false
    for (let i = 0; i < role.length; i++) {
      if (role[i].name === "Asset Attributes") {
        if (role[i].write === true) {
          canEdit = true
        }

      }
    }
    if (canEdit && spaceConfig) {
      setEditAllowed(true)
      setToggleEditBool(true)
    }
  }

  const tenant = TenantService.getTenant()

  function getData() {
    SpacesService.getSpaces(tenant).then((value) => {
      let response = value.data
      let myData = [{ id: null, name: "Unparented" }]
      for (let i = 0; i < response.data.length; i++) {
        myData[i + 1] = response.data[i]
      }
      setHeadData(myData)
      setData(response.data)
      if (response.data.length === 0) {
        setLoadingText("No Data")
      }
    })
  }

  function assetsText(e) {
    if (e.data.hasFloorplan) {
      return (
        <>
          View
        </>
      )
    }
  }

  function gatewaysText(e) {
    if (e.data.floorplan !== null) {
      if (editAllowed) {
        return (
          <>
            Edit
          </>
        )
      } else {
        return (
          <>
            View
          </>
        )
      }

    }
  }

  function anchorsText(e) {
    if (e.data.floorplan !== null) {
      if (editAllowed) {
        return (
          <>
            Edit
          </>
        )
      } else {
        return (
          <>
            View
          </>
        )
      }

    }

  }

  function floorplanText(e) {
    // console.log("e", e)
    if (e.data.model.id === 5 && e.column.caption !== "Zone") {
      return (
        <>
          View
        </>
      )
    }
    else if (e.data.hasFloorplan) {
      // console.log(e.data)
      if (toggleEditBool === true || toggleEditBool === "true") {
        if (e.data.operationsAllowed !== undefined) {
          if (e.data.operationsAllowed.updateZone) {
            return (
              <>
                Edit
              </>
            )
          }
        }

      } else {
        return (
          <>
            View
          </>
        )
      }
    }

  }
  // function floorplanText(e) {
  //   console.log("e.column.caption",e.column.caption)
  //   console.log("toggleEditBool",toggleEditBool)
  //   console.log("e.rowType",e.rowType)
  //   console.log("e.data.operationsAllowed",e.data.operationsAllowed)
  //   if ((e.column.caption === 'Map' && (toggleEditBool === true || toggleEditBool === "true")) && e.rowType !== "data") {
  //     if (e.data.operationsAllowed !== undefined) {
  //       if (e.data.operationsAllowed.updateZone) {
  //         return (
  //           <>
  //             View
  //           </>
  //         )
  //       }
  //     }
  //   }

  // }


  function uploadText(e) {

    if (e.data.operationsAllowed !== undefined) {
      if (e.data.operationsAllowed.uploadFloorplan)
        return (
          <>
            Edit
          </>
        )
    } else {
    }

  }

  function buttonColor(e) {
    if ((e.column.caption === 'Map') && e.rowType !== "header") {
      if ((e.data.hasFloorplan || e.data.model.id === 5) && (toggleEditBool === false || toggleEditBool === "false" || toggleEditBool === null)) {
        e.cellElement.style.color = "#d71109";
        e.cellElement.style.setProperty('cursor', 'pointer', 'important')
      }
    }
    if (toggleEditBool === true || toggleEditBool === "true") {
      if ((e.column.caption === 'Zone') && e.rowType !== "header") {
        if (e.data.operationsAllowed !== undefined) {
          if (e.data.operationsAllowed.updateZone && e.data.hasFloorplan) {
            e.cellElement.style.color = "#d71109";
            e.cellElement.style.setProperty('cursor', 'pointer', 'important')
          }
        }
      }
    }
    if (e.column.caption === 'Assets' && e.rowType !== "header") {
      if (e.data.hasFloorplan) {

        e.cellElement.style.color = "#d71109";
        e.cellElement.style.setProperty('cursor', 'pointer', 'important')
      }
    }
    if (e.column.caption === 'Anchors' && e.rowType !== "header") {
      if (e.data.floorplan !== null) {

        e.cellElement.style.color = "#d71109";
        e.cellElement.style.setProperty('cursor', 'pointer', 'important')
      }
    }
    if ((e.column.caption === 'Map' && (toggleEditBool === true || toggleEditBool === "true")) && e.rowType !== "header") {
      if (e.data.operationsAllowed !== undefined) {
        if (e.data.operationsAllowed.uploadFloorplan) {

          e.cellElement.style.color = "#d71109";
          e.cellElement.style.setProperty('cursor', 'pointer', 'important')
        }
      }
    }
    if (e.column.caption === 'Gateways' && e.rowType !== "header") {
      if (e.data.floorplan !== null) {
        e.cellElement.style.color = "#d71109";
        e.cellElement.style.setProperty('cursor', 'pointer', 'important')
      }
    }
  }

  useEffect(() => {
    if (uploadPopupVisible === true) {
      history.push({
        pathname: `/upload`,
        state: {
          spaceId: uploadSpaceId,
          toggle: null,
          showDelete: true
        }
      })
      setUploadPopupVisible(false)
    }

  }, [uploadPopupVisible]);

  function showInfo2(e) {
    if (!e?.row) return;
    const { data } = e.row;
    const column = e.column.caption;
    const id = data.id;
    const name = e.data.name;
    const isEdit = toggleEditBool === true || toggleEditBool === "true";

    function openFloorplan({ title, type, anchors = false, gateways = false }) {
      setSpaceId(id);
      setRenderFloorplan(true);
      setGetAnchors(anchors);
      setGetGateways(gateways);
      setTitle(title);
      setType(type);
      setPopupVisible(true);
    }

    // EDIT MODE
    if (isEdit && data.operationsAllowed) {
      if (data.model.id === 5) {
        history.push({
          pathname: `/geoUpload/${id}`, // ONLY the GUID here
          search: '?edit=true'          // query string separate
        });
      } else {
        if (column === "Map" && data.operationsAllowed.uploadFloorplan) {
          setUploadSpaceId(id);
          setUploadPopupVisible(true);
          return;
        }

        if (column === "Zone" && data.hasFloorplan && data.operationsAllowed.updateZone) {
          setZoneEditControl(true);
          openFloorplan({
            title: `Zone Edit - ${name}`,
            type: "polygonEdit",
          });
          return;
        }
      }
    }

    // VIEW / OTHER COLUMNS
    switch (column) {
      case "Map":
        if (data.hasFloorplan && !isEdit) {
          openFloorplan({
            title: `Floorplan - ${name}`,
            type: editAllowed ? "polygon" : "polygonView",
          });
        }
        else if (data.model.id === 5 && !isEdit) {
          history.push({
            pathname: `/geoUpload/${id}`, // ONLY the GUID here
            search: '?edit=false'          // query string separate
          });
        }
        break;

      case "Anchors":
        if (data.floorplan) {
          openFloorplan({
            title: `Anchors - ${name}`,
            type: editAllowed ? "anchors" : "anchorsView",
            anchors: true,
          });
        }
        break;

      case "Gateways":
        if (data.floorplan) {
          openFloorplan({
            title: `Gateways - ${name}`,
            type: editAllowed ? "gateways" : "gatewaysView",
            gateways: true,
          });
        }
        break;

      case "Assets":
        if (data.hasFloorplan) {
          AssetsService.getParenthierarchySpacesName(id).then((res) => {
            setTitle(`Assets - ${res?.data?.data || name}`);
          });

          AssetsService.getAssetsInSpace(id).then(() => {
            openFloorplan({
              title: `Assets - ${name}`,
              type: "assets",
            });
          });
        }
        break;

      default:
        // Do nothing for other columns
        break;
    }
  }



  // function showInfo2(e) {
  //   console.log("e", e)
  //   if (e.row !== undefined) {
  //     if (toggleEditBool === true || toggleEditBool === "true") {
  //       if (e.data.operationsAllowed !== undefined) {
  //         if (e.row.data.operationsAllowed.uploadFloorplan && e.column.caption === "Map") {
  //           setUploadSpaceId(e.row.data.id)
  //           setUploadPopupVisible(true)
  //         }
  //         if (e.row.data.hasFloorplan && e.column.caption === "Zone") {
  //           if (e.data.operationsAllowed.updateZone) {
  //             setZoneEditControl(true)
  //             setSpaceId(e.row.data.id)
  //             setRenderFloorplan(true)
  //             setGetAnchors(false)
  //             setGetGateways(false)
  //             setTitle(`Zone Edit - ${e.data.name}`)
  //             setType('polygonEdit')
  //             setPopupVisible(true)
  //           }
  //         }
  //       }


  //     } else {
  //       if (e.row.data.hasFloorplan && e.column.caption === "Map") {
  //         setSpaceId(e.row.data.id)
  //         setRenderFloorplan(true)
  //         setGetAnchors(false)
  //         setGetGateways(false)
  //         setTitle(`Floorplan - ${e.data.name}`)
  //         if (!editAllowed) {
  //           setType('polygonView');
  //         } else {
  //           setType('polygon');
  //         }
  //         setPopupVisible(true)
  //       }

  //     }


  //     if (e.row.data.floorplan !== null && e.column.caption === "Anchors") {
  //       setSpaceId(e.row.data.id)
  //       setRenderFloorplan(true)
  //       setGetAnchors(true)
  //       setGetGateways(false)
  //       setTitle(`Anchors - ${e.data.name}`)
  //       if (!editAllowed) {
  //         setType('anchorsView');
  //       } else {
  //         setType('anchors');
  //       }
  //       setPopupVisible(true)
  //     }
  //     if (e.row.data.floorplan !== null && e.column.caption === "Gateways") {
  //       setSpaceId(e.row.data.id)
  //       setRenderFloorplan(true)
  //       setGetAnchors(false)
  //       setGetGateways(true)
  //       setTitle(`Gateways - ${e.data.name}`)
  //       if (!editAllowed) {
  //         setType('gatewaysView');
  //       } else {
  //         setType('gateways');
  //       }
  //       setPopupVisible(true)
  //     }
  //     if (e.row.data.hasFloorplan && e.column.caption === "Assets") {
  //       let id = e.data.id
  //       AssetsService.getParenthierarchySpacesName(id).then((res) => {
  //         console.log('resPONSSSB', res);

  //         setTitle(`Assets - ${res?.data?.data ? res.data.data : e.data.name}`);
  //       })
  //       AssetsService.getAssetsInSpace(id).then((res) => {

  //         setSpaceId(e.row.data.id)
  //         setRenderFloorplan(true)
  //         setGetAnchors(false)
  //         setGetGateways(false)

  //         setType('assets')
  //         setPopupVisible(true)
  //       })
  //     }




  //   }
  // }

  function hideInfo() {
    setPopupVisible(false)
    setRenderFloorplan(false)
    setUploadPopupVisible(false)
    getData()
  }

  function onRowUpdating(e) {
    const id = e.oldData.id
    let name
    let model
    let type
    let parent

    if (e.newData.name !== undefined) {
      name = e.newData.name
    }
    if (e.newData.model !== undefined) {
      model = e.newData.model.id
    }
    if (e.newData.type !== undefined) {
      type = e.newData.type.id
    }
    if (e.newData.headId !== undefined) {
      parent = e.newData.headId
    }

    SpacesService.editSpace(id, name, parent, type, model).then((res) => {
      getData()
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: res.status === 200 ? 'success' : 'error',
        status: res?.data?.status ? res.data.status : res?.status,
        message: res?.data?.message ? res.data.message : res?.message,
      });
    })
  }

  function onRowInserted(e) {
    let headId = null
    if (e.data.headId !== 0) {
      headId = e.data.headId
    }

    SpacesService.addSpace(e.data.name, headId, e.data.type.id, e.data.model.id).then((res) => {
      getData()
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: res.status === 200 ? 'success' : 'error',
        status: res?.data?.status ? res.data.status : res?.status,
        message: res?.data?.message ? res.data.message : res?.message,
      });
    })


  }

  // function onRowRemoved(e) {
  //   setLoading(true)
  //   try {
  //     SpacesService.deleteSpace(e.data.id).then((res) => {
  //       setToastConfig({
  //         ...toastConfig,
  //         isVisible: true,
  //         type: res.status===200 ? 'success' : 'error',
  //         status: res?.data?.status ? res.data.status : res?.status,
  //         message: res?.data?.message ? res.data.message : res?.response?.data?.message,
  //       });
  //       getData()
  //     })
  //     setLoading(false)
  //   } catch (error) {
  //     setToastConfig({
  //       ...toastConfig,
  //       isVisible: true,
  //       type: 'error',
  //       status: 500,
  //       message: error,
  //     });
  //     setLoading(false)
  //   }
  // }

  function onRowRemoved(e) {
    setLoading(true)
    SpacesService.deleteSpace(e.data.id)
      .then((res) => {
        // Handle successful response
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: res.status === 200 ? 'success' : 'error',
          status: res?.data?.status ? res.data.status : res?.status,
          message: res?.data?.message ? res.data.message : res?.response?.data?.message,
        });
        getData(); // Fetch new data
      })
      .catch((error) => {
        // Handle error
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'error',
          status: 500,
          message: error,
        });
      })
      .finally(() => {
        setLoading(false); // Stop loader after response (success or error)
      });
  }


  function getModels() {
    SpacesService.getModels(tenant).then((value) => {
      let response = value.data
      setModels(response.data)
    })
  }


  function getTypes() {
    SpacesService.getSpaceTypes(tenant).then((value) => {
      let response = value.data
      let names = []
      let namesId = []
      for (let i = 0; i < response.data.length; i++) {
        names.push({
          name: response.data[i].name,
          id: response.data[i].id
        })
        namesId.push(response.data[i].id)


      }
      setTypes(names)
    })
  }

  useEffect(() => {
  }, [toggleEditBool]);

  const typeEditorOptions = {
    dataSource: types,
    searchEnabled: true,
    value: '',
    displayExpr: "name",
    valueExpr: "id",
    acceptCustomValue: false
  };

  const headIdEditorOptions = {
    dataSource: headData,
    searchEnabled: true,
    value: '',
    displayExpr: "name",
    valueExpr: "id",
    acceptCustomValue: false
  };

  // const headIdEditorOptions2 = { 
  //   dataSource: {headData}, 
  //   searchEnabled: true, 
  //   value: '', 
  //   displayExpr: "name",
  //   valueExpr: "id",
  //   acceptCustomValue: false
  // };

  const modelEditorOptions = {
    dataSource: geoAllowed ? models : models.filter(model => model.name !== "Geomap"),
    searchEnabled: true,
    value: '',
    displayExpr: "name",
    valueExpr: "id",
    acceptCustomValue: false
  }

  function allStorage() {

    var values = [],
      keys = Object.keys(localStorage),
      i = keys.length;

    while (i--) {
      values.push({
        key: keys[i],
        val: localStorage.getItem(keys[i])
      });
    }
  }

  useEffect(() => {
    if (popupVisible && type !== undefined) {
      let moveMarkers = null
      if (window.location.href.includes("config/space")) {
        moveMarkers = true
      }

      history.push({
        pathname: `/floorplan`,
        state: {
          spaceId: spaceId,
          myMarkers: getAnchors,
          type: type,
          windowType: { height: '90vh', width: '90vw' },
          toggleEditBool: toggleEditBool,
          title: title,
          moveMarkers: moveMarkers,
          zoneEditControl: zoneEditControl
        }
      })

    }

  }, [popupVisible]);

  useEffect(() => {
    if (popupVisible && type !== undefined) {
      let moveMarkers = null
      if (window.location.href.includes("config/space")) {
        moveMarkers = true
      }

      history.push({
        pathname: `/floorplan`,
        state: {
          spaceId: spaceId,
          myMarkers: getAnchors,
          type: type,
          windowType: { height: '90vh', width: '90vw' },
          toggleEditBool: toggleEditBool,
          title: title,
          moveMarkers: moveMarkers
        }
      })

    }

  }, [popupVisible]);

  function floorplanPop() {
    if (popupVisible && type !== undefined) {
      return (
        <FloorplanPopup spaceId={spaceId} myMarkers={getAnchors} type={type}>
        </FloorplanPopup>
      )
    } else {
      return (<></>)
    }
  }

  const [testPopup, setTestPopup] = useState(false)

  function closeTest() {
    setTestPopup(false)
  }

  function onSubmit(data) {
    console.log("edited:", editingRow)
    setEditingRow(null)
    setIsOpen(false)
  }

  function handleSave() {
    formRef.current?.requestSubmit();
  }

  function handleFormSave() {
    formFormRef.current?.requestSubmit();
  }

  function handleCloseDrawer() {
    setEditingRow(null)
    setFormData({
      id: null,
      headId: null,
      name: null,
      model: null,
      type: null
    })
    setPrevData(null)
    setIsOpen(false)
    setGeoAllowed(false)
  }

  function handleCloseFormDrawer() {
    setEditingRow(null)
    setFormFormData({
      id: null,
      headId: null,
      name: null,
      model: null,
      type: null
    })
    setPrevFormData(null)
    setIsOpenForm(false)
  }

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    const result = dxFormRef.current?.validate?.();
    if (result?.isValid) {
      if (formData && formData.id) {
        onRowUpdate()
      } else {
        onAddRow()
      }
      handleCloseDrawer();
    }
  }, [formData, handleCloseDrawer]);

  const handleFormSubmit = useCallback((e) => {
    e.preventDefault();
    const result = dxFormFormRef.current?.validate?.();
    if (result?.isValid) {
      if (formFormData && formFormData.id) {
        onFormRowUpdate()
      } else {
        onFormAddRow()
      }
      handleCloseFormDrawer();
    }
  }, [formFormData, handleCloseFormDrawer]);


  function onAddRow() {
    let { name, model, type, headId } = formData
    if (formData.headId !== 0) {
      headId = formData.headId
    }

    SpacesService.addSpace(name, headId, type, model).then((res) => {
      getData()
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: res.status === 200 ? 'success' : 'error',
        status: res?.data?.status ? res.data.status : res?.status,
        message: res?.data?.message ? res.data.message : res?.message,
      });
    })
  }

  function onFormAddRow() {
    let { name, model, type, headId } = formFormData
    if (formFormData.headId !== 0) {
      headId = formFormData.headId
    }

    SpacesService.addSpace(name, headId, type, model).then((res) => {
      getData()
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: res.status === 200 ? 'success' : 'error',
        status: res?.data?.status ? res.data.status : res?.status,
        message: res?.data?.message ? res.data.message : res?.message,
      });
    })
  }

  function onRowUpdate(e) {
    let { id, name, model, type, headId } = formData
    SpacesService.editSpace(id, name, headId, type, model).then((res) => {
      getData()
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: res.status === 200 ? 'success' : 'error',
        status: res?.data?.status ? res.data.status : res?.status,
        message: res?.data?.message ? res.data.message : res?.message,
      });
    })
      .catch((error) => {
        // This block runs when request fails
        console.error("API Error:", error);

        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'error',
          status: error?.response?.status || 500,
          message: error?.response?.data?.message || 'Failed to update space',
        });
      });
  }

  function onFormRowUpdate(e) {
    let { id, name, model, type, headId } = formFormData
    SpacesService.editSpace(id, name, headId, type, model).then((res) => {
      getData()
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: res.status === 200 ? 'success' : 'error',
        status: res?.data?.status ? res.data.status : res?.status,
        message: res?.data?.message ? res.data.message : res?.message,
      });
    })
      .catch((error) => {
        // This block runs when request fails
        console.error("API Error:", error);

        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'error',
          status: error?.response?.status || 500,
          message: error?.response?.data?.message || 'Failed to update space',
        });
      });
  }



  function handleAdd() {
    setIsNewRow(true); 
    setIsOpen(true);
    setGeoAllowed(true)
  }

  function addSubRow(e) {
    setFormFormData({
      id: null,
      headId: e?.row?.data?.id,
      name: '',
      model: null,
      type: null
    })
    setPrevFormData({
      id: null,
      headId: null,
      name: '',
      model: null,
      type: null
    })
    setIsOpenForm(true)
  }

  async function editRow(e) {
    setIsNewRow(false);
    setEditingRow(e.row?.data)
    setFormData({
      id: e.row?.data?.id,
      headId: e.row?.data?.headId,
      name: e.row?.data?.name,
      model: e.row?.data?.model?.id,
      type: e.row?.data?.type?.id
    })
    setPrevData({
      id: e.row?.data?.id,
      headId: e.row?.data?.headId,
      name: e.row?.data?.name,
      model: e.row?.data?.model?.id,
      type: e.row?.data?.type?.id
    })
    setIsOpen(true)
    setGeoAllowed(false)
  }

  function handleInputChange(e, name) {
    const value = name === "name" ? e?.value : e?.selectedItem;
    if (!value) return;

    setEditingRow(prev => ({
      ...prev,
      [name]: value
    }));
  }


  useEffect(() => {

  }, [getAnchors, type]);

  useEffect(() => {
    checkRole()
    allStorage()
    getModels()
    getTypes()
    getData()
  }, []);

  return (
    <>
      <div id="full-page-content-spaces" className="page-content" style={{ overflowY: "scroll" }} ref={downloadTargetRef}>
        <div className='headerHeadingPage'>
          <div className='pageFullWidthEvents'>
            <h5 className='marginZeroEvents'>
              <b>Spaces</b>
            </h5>
            <Popup
              visible={testPopup}
              onHiding={closeTest}
              dragEnabled={false}
              showCloseButton={true}
              showTitle={true}
              title={"Test Popup"}
              container=".dx-viewport"
            >
              <Position
                at="center"
                my="center"
              />
              <Test></Test>
            </Popup>
            <Toast
              setParentToastConfig={setToastConfig}
              toastBody={toastConfig}
            />
            {renderFloorplan &&
              <Popup
                visible={popupVisible}
                onHiding={hideInfo}
                dragEnabled={false}
                hideOnOutsideClick={setRenderFloorplan}
                showCloseButton={true}
                showTitle={true}
                title={title}
                container=".dx-viewport"
              >
                <Position
                  at="center"
                  my="center"
                />
                {floorplanPop()}
              </Popup>}
            <TreeList
              style={{ marginTop: "10px" }}
              noDataText={loadingText}
              showColumnLines={false}
              showRowLines={true}
              height={'calc(100vh - 51px)'}
              allowColumnResizing={true}
              id="tree-list"
              dataSource={data}
              keyExpr="id"
              parentIdExpr="headId"
              onCellPrepared={buttonColor}
              onCellClick={showInfo2}
              onRowUpdating={onRowUpdating}
              onRowInserted={onRowInserted}
              onRowRemoved={onRowRemoved}
              onToolbarPreparing={(e) => {
                if (toggleEditBool) {
                  e.toolbarOptions.items = e.toolbarOptions.items.filter(
                    (item) => item.name !== 'addRowButton'
                  );

                  e.toolbarOptions.items.unshift({
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                      icon: '',
                      text: '',
                      stylingMode: 'text',
                      // onClick: () => e.component.addRow(),
                      onClick: () => handleAdd(),
                      elementAttr: {
                        id: 'addTenantButton',
                      },
                      template: (buttonData, buttonElement) => {
                        const container = document.createElement('div');
                        container.style.display = 'flex';
                        container.style.alignItems = 'center';
                        container.style.justifyContent = 'center';

                        container.innerHTML = `
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" 
                           viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" 
                           stroke-linecap="round" stroke-linejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                    `;

                        buttonElement.appendChild(container);
                      }

                    },
                  });
                }
              }}
            >
              <Paging enabled={false} />
              <StateStoring enabled={true} type="localStorage" storageKey={tenant + "spaces"} />
              <Editing
                allowUpdating={toggleEditBool}
                allowDeleting={toggleEditBool}
                allowAdding={toggleEditBool}
                use-icons={true}
                mode="popup"
              // texts={{
              //   addRow: 'Add Space'
              // }}
              >
                <Texts
                  confirmDeleteMessage="Are you sure you want to delete this Space??"
                />
                {/* <Popup2
              showTitle={true}
              width={500}
              height={600}
              title="Space"
            /> */}
                <Form colCount={1}>
                  <Item dataField="name" isRequired={true} />
                  <Item dataField="model.id" isRequired={true}
                    editorType="dxSelectBox" editorOptions={modelEditorOptions}>
                    <Label text="Space Mobilty" />
                  </Item>
                  <Item dataField="type.id" isRequired={true}
                    editorType="dxSelectBox" editorOptions={typeEditorOptions}>
                    <Label text="Space Type" />
                  </Item>
                  <Item dataField="headId" isRequired={false}
                    visible={false}
                    editorType="dxSelectBox" editorOptions={headIdEditorOptions}>
                    <Label text="Parent Space" />
                  </Item>
                </Form>
              </Editing>
              <RemoteOperations />
              <Column
                dataField={DOMPurify.sanitize('name')}
                caption={'Space'}
                width={350}
              // fixed={true}
              />
              <Column
                dataField={DOMPurify.sanitize('model.name')}
                caption={'Space Category'}
                visible={true}
                width={350}
              // fixed={true}
              />
              <Column
                dataField={DOMPurify.sanitize('headId')}
                caption={'headId'}
                visible={false}
                width={350}
              // fixed={true}
              />
              <Column
                dataField={DOMPurify.sanitize('model.id')}
                caption={'model.id'}
                visible={false}
                width={350}
              // fixed={true}
              />
              <Column
                dataField={DOMPurify.sanitize('type.id')}
                caption={'type.id'}
                visible={false}
                width={350}
              // fixed={true}
              />
              <Column
                dataField={DOMPurify.sanitize('type.name')}
                caption={'Type'}
              // fixed={true}
              />
              <Column
                caption={(toggleEditBool === true || toggleEditBool === "true") ? 'Zone' : 'Map'}
                width={100}
                cellRender={floorplanText}
              // fixed={true}
              >
              </Column>
              <Column
                caption={(toggleEditBool === true || toggleEditBool === "true") ? 'Map' : 'Upload'}
                width={100}
                cellRender={uploadText}
                visible={toggleEditBool === true || toggleEditBool === "true"}
              // fixed={true}
              ></Column>
              <Column
                caption={'Anchors'}
                width={100}
                cellRender={anchorsText}
              // fixed={true}
              >
              </Column>
              <Column
                dataField={'id'}
                caption={'Assets'}
                cellRender={assetsText}
                width={80}
              // fixed={true}
              />
              <Column
                caption={'Gateways'}
                cellRender={gatewaysText}
                width={100}
              // fixed={true}
              />
              <Column type="buttons" visible={toggleEditBool} width={150}>
                <Button
                  name="add"
                  visible={(e) => e.row.data.model?.id !== 5}
                  onClick={(e) => {
                    const rowData = e.row.data;
                    console.log("Current Model ID:", rowData.model?.id);
                    addSubRow(e);
                  }}
                />
                <Button name="edit" onClick={editRow} />
                <Button name="delete" />
              </Column>
            </TreeList>
            <Tooltip
              target="#addTenantButton"
              showEvent="mouseenter"
              hideEvent="mouseleave"
              position="bottom"
            >
              <div className="custom-tooltip">Add Space</div>
            </Tooltip>
            <LoadingPanel
              shadingColor="rgba(0,0,0,0.4)"
              visible={loading}
              showIndicator={true}
              showPane={true}
              shading={true}
              hideOnOutsideClick={false}
            />
            <div className={`uploadBtnAssetsReport ${className} download_btn`} style={{ right: "24px", marginTop: "4px" }}>
              <button id="generatePdfButton" alt="Download Report" type="button" onClick={() => downloadReport()}>
                <img src="../icons/reports.svg" alt="Download Report" />
              </button>
              <Tooltip
                target="#generatePdfButton"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                position="bottom"
              // visible={true}
              >
                <div className="custom-tooltip">Download Report</div>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>


      <SlidingDrawer
        title={`Space`}
        isOpen={isOpenForm}
        onClose={handleCloseFormDrawer}
        handleSave={handleFormSave}
        formData={formFormData}
        prevData={prevFormData}
      >
        {isOpenForm &&
          <form ref={formFormRef} onSubmit={handleFormSubmit}>
            <div>
              <DxForm
                formData={formFormData}
                onFieldDataChanged={(e) => {
                  setFormData((prev) => {
                    const next = {
                      ...prev,
                      [e.dataField]: e.value,
                    };

                    if (next.model === 5) {
                      next.headId = null;
                    }

                    return next;
                  });
                }}
                onInitialized={(e) => {
                  dxFormFormRef.current = e.component;
                }}
                labelLocation="top"
                showColonAfterLabel={false}
                showValidationSummary={false}
              >
                <GroupItem colCount={1}>
                  <SimpleItem
                    dataField="name"
                    editorType="dxTextBox"
                    editorOptions={{
                      valueChangeEvent: 'input',
                    }}
                    validationRules={[{ type: 'required', message: 'Space is required' }]}
                  >
                    <Label text="Space" isRequired />
                  </SimpleItem>

                  <SimpleItem
                    dataField="model"
                    editorType="dxSelectBox"
                    editorOptions={{
                      items: modelEditorOptions?.dataSource || [],
                      displayExpr: 'name',
                      valueExpr: 'id',
                      placeholder: 'Select...',
                      // showClearButton: true,
                      searchEnabled: true,
                      dropDownOptions: {
                        container: '.slide-pane'
                      },
                      itemRender: (item) => (
                        <div className="custom-item">
                          <div className="product-name">{item.name}</div>
                        </div>
                      ),
                    }}
                    validationRules={[{ type: 'required', message: 'Space Category is required' }]}
                  >
                    <Label text="Space Category" isRequired />
                  </SimpleItem>

                  <SimpleItem
                    dataField="type"
                    editorType="dxSelectBox"
                    editorOptions={{
                      items: typeEditorOptions?.dataSource || [],
                      displayExpr: 'name',
                      valueExpr: 'id',
                      placeholder: 'Select...',
                      // showClearButton: true,
                      searchEnabled: true,
                      dropDownOptions: {
                        container: '.slide-pane'
                      },
                    }}
                    validationRules={[{ type: 'required', message: 'Space Type is required' }]}
                  >
                    <Label text="Space Type" isRequired />
                  </SimpleItem>

                  <SimpleItem
                    dataField="headId"
                    editorType="dxSelectBox"
                    editorOptions={{
                      items: headIdEditorOptions?.dataSource || [],
                      displayExpr: 'name',
                      valueExpr: 'id',
                      placeholder: 'Select a device',
                      // showClearButton: true,
                      searchEnabled: true,
                      dropDownOptions: {
                        container: '.slide-pane'
                      },
                    }}
                  >
                    <Label text="Parent Space" />
                  </SimpleItem>
                </GroupItem>
              </DxForm>
            </div>
          </form>
        }
      </SlidingDrawer>


      <SlidingDrawer
        title={`Space2`}
        isOpen={isOpen}
        onClose={handleCloseDrawer}
        handleSave={handleSave}
        formData={formData}
        prevData={prevData}
      >
        {isOpen &&
          <form ref={formRef} onSubmit={handleSubmit}>
            <div>
              <DxForm
                formData={formData}
                onFieldDataChanged={(e) => {
                  setFormData((prev) => {
                    const next = {
                      ...prev,
                      [e.dataField]: e.value,
                    };

                    if (next.model === 5) {
                      next.headId = null;
                    }

                    return next;
                  });
                }}
                onInitialized={(e) => {
                  dxFormRef.current = e.component;
                }}
                labelLocation="top"
                showColonAfterLabel={false}
                showValidationSummary={false}
              >
                <GroupItem colCount={1}>
                  <SimpleItem
                    dataField="name"
                    editorType="dxTextBox"
                    editorOptions={{
                      valueChangeEvent: 'input',
                    }}
                    validationRules={[{ type: 'required', message: 'Space is required' }]}
                  >
                    <Label text="Space" isRequired />
                  </SimpleItem>
                  <SimpleItem
                    dataField="model"
                    editorType="dxSelectBox"
                    editorOptions={{
                      items: modelEditorOptions?.dataSource || [],
                      displayExpr: 'name',
                      valueExpr: 'id',
                      placeholder: formData.model === 5 && !isNewRow ? 'Geomap':'Select...',
                      disabled: formData.model === 5 && !isNewRow,
                      // showClearButton: true,
                      searchEnabled: true,
                      dropDownOptions: {
                        container: '.slide-pane'
                      },
                      itemRender: (item) => (
                        <div className="custom-item">
                          <div className="product-name">{item.name}</div>
                        </div>
                      ),
                    }}
                    validationRules={[{ type: 'required', message: 'Space Category is required' }]}
                  >
                    <Label text="Space Category" isRequired />
                  </SimpleItem>

                  <SimpleItem
                    dataField="type"
                    editorType="dxSelectBox"
                    editorOptions={{
                      items: typeEditorOptions?.dataSource || [],
                      displayExpr: 'name',
                      valueExpr: 'id',
                      placeholder: 'Select...',
                      // showClearButton: true,
                      searchEnabled: true,
                      dropDownOptions: {
                        container: '.slide-pane'
                      },
                    }}
                    validationRules={[{ type: 'required', message: 'Space Type is required' }]}
                  >
                    <Label text="Space Type" isRequired />
                  </SimpleItem>

                  <SimpleItem
                    dataField="headId"
                    editorType="dxSelectBox"
                    editorOptions={{
                      items: headIdEditorOptions?.dataSource || [],
                      displayExpr: 'name',
                      valueExpr: 'id',
                      placeholder: 'Select a device',
                      // showClearButton: true,
                      searchEnabled: true,
                      dropDownOptions: {
                        container: '.slide-pane'
                      },
                    }}
                  >
                    <Label text="Parent Space" />
                  </SimpleItem>
                </GroupItem>
              </DxForm>
            </div>
          </form>
        }
      </SlidingDrawer>
    </>
  );
}